export const GET_CERTIFICATE_BEGIN = 'get_certificate_begin';
export const GET_CERTIFICATE_REQUESTING = 'get_certificate_requesting';
export const GET_CERTIFICATE_SUCCESS = 'get_certificate_success';
export const GET_CERTIFICATE_ERROR = 'get_certificate_error';
export const GET_CERTIFICATE_RESET = 'get_certificate_reset';

export const Edit_CERTIFICATE_BEGIN = 'edit_certificate_begin';
export const Edit_CERTIFICATE_REQUESTING = 'edit_certificate_requesting';
export const Edit_CERTIFICATE_SUCCESS = 'edit_certificate_success';
export const Edit_CERTIFICATE_ERROR = 'edit_certificate_error';
export const Edit_CERTIFICATE_RESET = 'edit_certificate_reset';

export const GET_CERTIFICATE_BY_ID_BEGIN = 'get_certificate_by_id_begin';
export const GET_CERTIFICATE_BY_ID_REQUESTING = 'get_certificate_by_id_requesting';
export const GET_CERTIFICATE_BY_ID_SUCCESS = 'get_certificate_by_id_success';
export const GET_CERTIFICATE_BY_ID_ERROR = 'get_certificate_by_id_error';
export const GET_CERTIFICATE_BY_ID_RESET = 'get_certificate_by_id_reset';

export const GET_CERTIFICATE_TEMPLATES_BEGIN = 'get_certificate_templates_begin';
export const GET_CERTIFICATE_TEMPLATES_REQUESTING = 'get_certificate_templates_requesting';
export const GET_CERTIFICATE_TEMPLATES_SUCCESS = 'get_certificate_templates_success';
export const GET_CERTIFICATE_TEMPLATES_ERROR = 'get_certificate_templates_error';
export const GET_CERTIFICATE_TEMPLATES_RESET = 'get_certificate_templates_reset';